/* */ 
'use strict';
Object.defineProperty(exports, "__esModule", {value: true});
exports.default = isInt;
var _assertString = require('./util/assertString');
var _assertString2 = _interopRequireDefault(_assertString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
function isInt(str, options) {
  (0, _assertString2.default)(str);
  options = options || {};
  return int.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max);
}
module.exports = exports['default'];
